export default {"src":"/_next/static/media/success.751c7c33.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};